//Obligé d'avoir des variables globales pour <=IE9
iCptWait3Dsoft = 0;
//bAjaxTermine3Dsoft = false;
bIEOld3Dsoft = false;

function Widget3dsoft(sId, sJWT, sLang, aOptions) {

    /**
     * 
     */
    this.aOptions = aOptions;

    /**
     * The class where go to show our forms
     * @var string
     */
    this.sClass = (sId == undefined) ? '#widget-3dsoft' : sId;

    this.sVarName = this.sClass.substring(1);

    this.profilerActif = (aOptions != undefined && aOptions.profilerActif != undefined) ? aOptions.profilerActif : false;

    /**
     * @var string
     */
    this.sClientName;

    /**
     * @var string
     */
    this.sCfaLibelle = 'default';

    /**
     * 
     */
    this.oSite;

    /**
     * Params in all url
     * (sClientName and sCfaLibelle)
     * ?sClientName=xxxxx&sCfaLibelle=yyyyy
     */
    this.sParamsGet;

    this.bAjaxTermine3Dsoft = false;

    this.iAdapDimension = 0;
    this.iMaxAdapDimension = 10;

    /**
     * Server of the widget
     * @var string
     */
    this.sServerURL = (aOptions != undefined && aOptions.sServerURL != undefined) ? aOptions.sServerURL : "https://api.3dsoft.fr/";

    this.iNoPageSearch;

    /**
     * Css of the widget
     * @var string
     */
    this.sCss = "style.min.css";

    /**
     * 
     */
    this.sStep = 'stepConnexion';

    this.bStepSearchHasToggledCalendar = false;

    /**
     * Taille affichees de caracteres dans l'en-tete des clients
     */
    this.iNbCaracteresNomPrenom = 20;

    this.oSearchClient = {
        sTel: null,
        sNom: null,
        sPrenom: null,
        sImmatriculation: null,
        sVin: null
    }

    /**
     * @var boolean
     */
    this.oUser = {
        sUsername: null,
        iId: null,
        nom: null,
        prenom: null,
    }


    /**
     * @var Array
     */
    this.aSearchClientRdvs;

    /**
     * @var Array
     */
    this.aInterventions = [];

    /**
     * @var int
     */
    this.iNbSelectInterventions = 0;

    /**
     * @var int
     */
    this.iMAXNbSelectInterventions = 5;

    /**
     * @var Array
     */
    this.aMois;

    /**
     * {"2015-11-05" : {
     "day": "2015-11-05",
     "type": 0
     },...}
     */

    /**
     * @var json
     */
    this.jCalendrier = [];

    /**
     * @var json
     */
    this.jReception = {};

    /**
     * @var json
     */
    this.jReceptionsHours = {};

    /**
     * @var json
     */
    this.aReception = {};

    /**
     * @var int
     */
    this.sAnnee = null;

    /**
     * @var string
     */
    this.sMois = null;

    /**
     * @var string
     */
    this.iDay = null;

    /**
     * 
     */
    this.aVehicules;

    /**
     * 
     */
    this.aMarques = [];

    /**
     * 
     */
    this.aModeles = [];

    /**
     * 
     */
    this.aAteliers;

    /**
     * 
     */
    this.aVehCourtoisie = [];

    /**
     * 
     */
    this.oJourSeuilsCharge = {
        depassee: 1.2,
        plein: 1,
        possible: 0.80
    };
    /**
     * 
     */
    this.Customer = [];
    /**
     * 
     */
    this.Vehicule = [];
    /**
     * 
     */
    this.WorkFile = [];

    /**
     * Indique si on est en mode modification ou crÃ©ation de rendez vous
     */
    this.updateRdvActif = false;

    this.aCodeError = {
        RDV_ERROR_CODE_CLIENT: 1,
        RDV_ERROR_CODE_VEHICULE: 2,
        RDV_ERROR_CODE_VEHICULE_CLIENT: 3,
        RDV_ERROR_CODE_MODELE: 4,
        RDV_ERROR_CODE_INTERVENTION: 5,
        RDV_ERROR_CODE_INTERVENTION_MAX: 6,
        RDV_ERROR_CODE_INTERVENTION_NOT_ALLOWED: 7,
        RDV_ERROR_CODE_DATE_BAD_FORMAT: 8,
        RDV_ERROR_CODE_DATE_HOUR_OUT_OF_LIMITS: 9,
        RDV_ERROR_CODE_DATE_RECEPTION_NOT_DEFINED: 10,
        RDV_ERROR_CODE_DATE_NO_AVAILABILITY: 11,
        RDV_ERROR_CODE_RECEPTION_NOT_AVAILABLE: 12,
        RDV_ERROR_CODE_RECEPTION_NOT_DEFINED: 13,
    };

    /**
     * 
     */
    this.rendezvous = {
        iIdClient: null,
        iIdRendezvous: null, //pour la modification

        //Infos client
        civilite: null,
        sNom: null,
        sPrenom: null,
        telmob: null,
        teldom: null,
        telbur: null,
        email: null,
        adresse: null,
        cp: null,
        ville: null,
        //Veicule
        iIdVehicule: null,
        sImmatriculation: null,
        iIdMarque: null,
        iIdModele: null,
        sMarqueLibelle: null,
        sModeleLibelle: null,
        sVin: null,
        iKm: null,
        //Interventions
        aInterventions: [],
        iDureeTotale: 0,
        sCommentaire: null,
        //Date
        sDateMec: null,
        sDateReception: null,
        sDateRestitution: null,
        iHeureReception: null,
        iHeureRestitution: null,
        //Atelier
        iIdAtelier: null,
        //Receptionnaire
        iIdReceptionnaire: null,
        //Vehicule de courtoisie
        iIdVehCourtoisie: null,
        vehCourtoisie: null,
        bVehiculeRemplacement: null,
        bLeClientAttend: false,
        bVehCourtoisie: false,
        bShuttle: false,
        // user
        iIdUti: null
    };

    /**
     * 
     */
    this.sLanguage = null;

    this.init(sJWT, sLang, aOptions);
}

module.exports = Widget3dsoft;
